import { filterProposals } from 'common/api/v1/designs';

import {
    FETCH_PROPOSALS,
    FETCH_PROPOSALS_FAILURE,
    FETCH_PROPOSALS_SUCCESS,
} from '../actionTypes';
import { rackingProposalsActions } from '../reducer';

export default (filterData = {}) =>
    (dispatch) => {
        dispatch(rackingProposalsActions[FETCH_PROPOSALS]());

        const {
            orderBy = 'created_at',
            page = 0,
            pageSize = 25,
            searchText = '',
            sortBy = 'desc',
        } = filterData;

        const ordering = sortBy === 'asc' ? orderBy : `-${orderBy}`;

        filterProposals({
            page: page + 1,
            perPage: pageSize,
            searchText,
            ordering,
        })
            .then((response) =>
                dispatch(
                    rackingProposalsActions[FETCH_PROPOSALS_SUCCESS](
                        response.data,
                    ),
                ),
            )
            .catch((error) =>
                dispatch(
                    rackingProposalsActions[FETCH_PROPOSALS_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
